import React from 'react';
import { artistInfo, socialLinks } from '../mock';
import { Music, Instagram, Music2 } from 'lucide-react';

const Footer = () => {
  const iconMap = {
    Music: Music,
    Instagram: Instagram,
    Music2: Music2
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black border-t border-white/25 py-16">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-[7.6923%]">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3 cursor-pointer" onClick={scrollToTop}>
              <div className="bg-turquoise-solid w-12 h-12 flex items-center justify-center">
                <span className="font-bold text-2xl">JL</span>
              </div>
              <span className="text-white font-bold text-2xl">{artistInfo.name}</span>
            </div>
            <p className="body-medium text-white/85">{artistInfo.tagline}</p>
            <p className="body-small text-white/70">{artistInfo.location}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 id="footer-navigate-heading" className="subsection-title mb-4 footer-heading footer-heading-md">Navigate</h4>
            <nav className="space-y-2">
              <a id="footer-link-about" href="#about" className="footer-nav-link block body-medium text-white/70 hover:text-brand-turquoise transition-colors footer-link-visible">
                <span className="footer-nav-text">About</span>
              </a>
              <a id="footer-link-music" href="#music" className="footer-nav-link block body-medium text-white/70 hover:text-brand-turquoise transition-colors footer-link-visible">
                <span className="footer-nav-text">Music</span>
              </a>
              {/* <a href="#videos" className="block body-medium text-white/70 hover:text-[#00FFD1] transition-colors">
                Videos
              </a> */}
              <a id="footer-link-gallery" href="#gallery" className="footer-nav-link block body-medium text-white/70 hover:text-brand-turquoise transition-colors footer-link-visible">
                <span className="footer-nav-text">Gallery</span>
              </a>
              <a id="footer-link-booking" href="#booking" className="footer-nav-link block body-medium text-white/70 hover:text-brand-turquoise transition-colors footer-link-visible">
                <span className="footer-nav-text">Booking</span>
              </a>
              <a id="footer-link-website" href={`https://${artistInfo.website}`} target="_blank" rel="noopener noreferrer" className="footer-nav-link block body-medium text-white/70 hover:text-brand-turquoise transition-colors footer-link-visible">
                <span className="footer-nav-text">{artistInfo.website}</span>
              </a>
            </nav>
          </div>

          {/* Social Media */}
          <div>
            <h4 id="footer-follow-heading" className="subsection-title mb-4 footer-heading footer-heading-md">Listen & Follow</h4>
            <nav className="space-y-2">
              {socialLinks.map((link) => {
                const Icon = iconMap[link.icon] || Music;
                return (
                  <a
                    key={link.platform}
                    id={`footer-social-${link.platform}`}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-social-link flex items-center gap-3 body-medium text-white/70 hover:text-brand-turquoise transition-colors group music-link-visible"
                  >
                    <div className="w-10 h-10 bg-white/10 border border-white/25 flex items-center justify-center group-hover:bg-brand-turquoise group-hover:border-brand-turquoise transition-all">
                      <Icon className="text-white group-hover:text-black transition-colors" size={18} />
                    </div>
                    <span id={`footer-social-text-${link.platform}`} className="footer-social-text music-text-nowrap">{link.label}</span>
                  </a>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/25 text-center">
          <p className="body-small text-white/70">
            © {new Date().getFullYear()} {artistInfo.name}. Kelowna, BC.
          </p>
          <p className="body-small text-white/70 mt-2">
            <a href={`https://${artistInfo.website}`} target="_blank" rel="noopener noreferrer" className="hover:text-brand-turquoise transition-colors">
              {artistInfo.website}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;